<template>
  <div>
    <a
      v-if="companyId && !isExporting"
      href="#"
      title=""
      class="action-bar__link"
      @click.prevent="exportEmployees"
    >{{ $t(`${namespace}.export`) }}</a>

    <a
      v-else-if="isExporting"
      href="#"
      class="action-bar__link"
      slot="activator"
      @click.prevent
    >
      {{ $t('Common.exporting') }}
    </a>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { exportAsync } from 'utils/exportAsync'

export default {
  name: 'ExportEmployeesAction',
  props: {
    search: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState({
      company: state => state.company.selectedCompany
    }),

    companyId () {
      if (this.$route.name === 'CompanyDetail') {
        return this.$route.params.id
      }

      return this.company ? this.company.id : null
    }
  },
  data () {
    return {
      namespace: 'Views.EmployeesPage',
      isExporting: false,
      downState: {
        downloadCsvAutoRequest: undefined,
        downloadCsvPercentage: 0
      }
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show',
      successAlert: 'snackbarAlert/success'
    }),

    onExportAsyncSuccess () {
      this.successAlert(this.$t(`${this.namespace}.successExport`))
      this.isExporting = false
    },

    onExportAsyncError () {
      this.showAlert({
        type: 'error',
        message: this.$t('Common.errorExport')
      })
      this.isExporting = false
    },

    async exportEmployees () {
      this.isExporting = true

      try {
        exportAsync(
          { companyId: this.company.id, search: this.search, type: 'configEmployee' },
          '99Empresas_colaboradores.csv',
          this.onExportAsyncSuccess,
          this.onExportAsyncError,
          this.downState
        )
      } catch (err) {
        this.isExporting = false
        console.log('Error trying to export', err)
      }
    }
  },
  destroyed () {
    // clearInterval(this.downState.downloadCsvAutoRequest)
  }
}
</script>
